import StickyLayoutProvider from './hooks/useStickyLayout';

import { StickyLayoutProps } from './@types/StickyLayoutProps';
import StickyLayoutWrapper from './handles/StickyLayoutWrapper';
import StickyLayoutContainer from './handles/StickyLayoutContainer';

const StickyLayout = (props: StickyLayoutProps) => (
	<StickyLayoutProvider {...props}>
		<StickyLayoutWrapper>
			<StickyLayoutContainer>{props.children}</StickyLayoutContainer>
		</StickyLayoutWrapper>
	</StickyLayoutProvider>
);

export default StickyLayout;
